import { useEffect } from "react"
import { useAppDispatch, useAppSelector } from "../../hooks"
import DeleteAccount from "../../pages/DeleteAccount"
import { Loading } from "./Loading"
import { selectIdToken } from "./authSlice"
import { getIdToken } from "./authThunks"

export function Token() {
  const idToken = useAppSelector(selectIdToken)
  // Check if user has a token and fetch if not.
  const dispatch = useAppDispatch()
  useEffect(() => {
    if (!idToken) {
      dispatch(getIdToken())
    }
  }, [idToken, dispatch])

  return idToken ? <DeleteAccount /> : <Loading />
}
